/* Acorn & Pip — size filter tidy
   - Size filter moves to the top of the filter list and starts open.
   - Clothing collections hide shoe sizes; shoe collections hide clothing ages
     (mode set by the A&P Collection header section; anywhere else shows everything).
   - Shoe labels shortened: "Shoe Sizes UK 7 - EU 24" -> "UK 7 · EU 24".
   Works with the theme's AJAX filtering by re-applying whenever the filters re-render. */
(function () {
  if (window.__apFilters) return; window.__apFilters = true;

  var SHOE = /^\s*Shoe Sizes\s+/i;
  var userClosed = false;

  function mode() {
    var el = document.querySelector('[data-ap-size-mode]');
    return el ? el.getAttribute('data-ap-size-mode') : 'both';
  }

  function shortLabel(text) {
    // "Shoe Sizes UK 7 - EU 24" -> "UK 7 · EU 24"
    return text.replace(SHOE, '').replace(/\s*-\s*EU\s*/i, ' · EU ').trim();
  }

  function sizeGroup(root) {
    var input = root.querySelector('input[name="filter.v.option.size"]');
    return input ? input.closest('.filter-group') : null;
  }

  function apply() {
    var forms = document.querySelectorAll('#CollectionFilterForm, .filters form');
    var m = mode();
    forms.forEach(function (form) {
      var group = sizeGroup(form);
      if (!group || group.getAttribute('data-ap-done') === '1') return;
      group.setAttribute('data-ap-done', '1');

      // Hide the other kind of size, unless a shopper has already ticked it
      var shown = 0;
      group.querySelectorAll('label.filter-group__item').forEach(function (label) {
        var textEl = label.querySelector('.filter-group__item__text');
        var input = label.querySelector('input');
        if (!textEl) return;
        var raw = textEl.getAttribute('data-ap-raw') || textEl.textContent.trim();
        textEl.setAttribute('data-ap-raw', raw);
        var isShoe = SHOE.test(raw);
        var hide = (m === 'clothing' && isShoe) || (m === 'shoes' && !isShoe);
        if (input && input.checked) hide = false;
        label.hidden = hide;
        if (!hide) shown++;
        if (isShoe) textEl.textContent = shortLabel(raw);
      });
      if (shown === 0) { group.hidden = true; return; }

      // Move Size to the top (after the in-stock toggle) and open it
      var first = form.querySelector('.filter-group:not(.filter-group--availability):not(.filter-group--applied)');
      if (first && first !== group) first.parentNode.insertBefore(group, first);
      if (!userClosed) {
        var heading = group.querySelector('.filter-group__heading');
        var items = group.querySelector('.filter-group__items');
        if (heading) heading.classList.remove('toggle-target-toggler--is-hidden');
        if (items) items.classList.remove('toggle-target--hidden');
      }
    });

    // Shorten shoe sizes in the "Applied filters" pills too
    document.querySelectorAll('.filter-group__applied-item__text').forEach(function (el) {
      var t = el.textContent.trim();
      if (SHOE.test(t)) el.textContent = shortLabel(t);
    });
  }

  // Remember if the shopper closes Size themselves, so we don't keep reopening it
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.filter-group__heading');
    if (!h) return;
    var g = h.closest('.filter-group');
    if (g && g.querySelector('input[name="filter.v.option.size"]')) {
      setTimeout(function () { userClosed = h.classList.contains('toggle-target-toggler--is-hidden'); }, 0);
    }
  }, true);

  var queued = false;
  function soon() {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }

  function start() {
    var css = document.createElement('style');
    css.textContent = '.filter-group__item[hidden],.filter-group[hidden]{display:none!important}';
    document.head.appendChild(css);
    apply();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', apply);
})();
